import { PatientInterface } from '../interfaces';
import { createTableColumns } from '../utils';

import Axios from "../libraries/axios";

class PatientModel implements PatientInterface {
  [key: string]: any
  _id = '';
  ambassadorId = '';
  source = '';
  firstName = '';
  lastName = '';
  email = '';
  phone = '';
  gender = '';
  height = 0;
  weight = 0;
  birthDate = '';
  product = '';
  address = {
    street1: '',
    street2: '',
    city: '',
    state: '',
    zip: ''
  };
  patientApiPayload = {};
  patientId = '';
  patientApiResponse = {};
  voucherApiPayload = {};
  voucherApiResponse = {};
  intakeFormPayload = {};
  currentPrescription = '';
  isIntakeComplete = false;
  transactions = [];
  paid = false;
  refunded = false;
  createdAt = new Date();
  updatedAt = new Date();
  hubspot = {
    contactId: '',
    dealId: '',
  };

  constructor(props: PatientInterface) {
    if (props) {
      Object.assign(this, props);
    }
  }

  static getColumns() {
    return createTableColumns(['email', 'firstName', 'lastName', 'gender', 'height', 'weight', 'paid', 'refunded', 'phone', 'product', 'createdAt']);
  }

  static async get(id: string): Promise<any> {
    const { data } = await Axios.get(`/api/patients/${id}`);

    return data;
  }

  static async fetchAll<ReturnType>(
    params: any = {},
    config: any = {}
  ): Promise<ReturnType> {
    try {
      const { data } = await Axios.get('/api/patients', {
        params,
        ...config,
      });

      return data;
    } catch (e: any) {
      console.log(e);

      throw new Error(e);
    }
  }

  static async update(
    id: string,
    patient: PatientInterface
  ): Promise<any> {
    try {
      const { data } = await Axios.patch(`/api/patients/${id}`, patient);
      return data;
    } catch (e: any) {
      throw new Error(e);
    }
  }

  static async voucherRefill(
    patientId: string
  ): Promise<any> {
    try {
      const { data } = await Axios.post(`/api/patients/voucher-refill`, {
        patient_id: patientId
      });
      return data;
    } catch (e: any) {
      throw new Error(e);
    }
  }
}

export default PatientModel;
